import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { actions as userActions } from '../../actions/userActions';
import * as types from '../../constants/actionTypes';
import Notification from '../Common/Notification';
import RadioGroup from '../Common/RadioGroup/RadioGroup';
import MultiSelectBox from './../Common/MultiSelectBox/MultiSelectBox';
import Button from './../Common/Button';
import Icon from './../Common/Icon';
import { CUSTOMER_ROLES } from '../../constants/roles';
import Routes from '../../constants/routes';
import moment from 'moment';
import { DailyDigestPopover, WeeklyDigestPopover } from '../../constants/constants';
import $ from 'jquery';
window.jQuery = $;
require('bootstrap');
import Toggle from './../Common/Toggle/Toggle';
import LoadingIndicator from './../Common/LoadingIndicator/LoadingIndicator';

export class NotificationSettingsForm extends React.Component {
    constructor(props, context) {
        super(props, context);

        this.state = {
            showAdminSection: props.userRole === CUSTOMER_ROLES.Owner.name ||
                props.userRole === CUSTOMER_ROLES.Moderator.name ||
                props.userRole === CUSTOMER_ROLES.Admin.name,
            userDefaultLocation: "",
            isProjectWidgetActive: false,
            isLoading: false,
            locations: [],
            locationIds: [],
            daysOfTheWeek: [],
            hoursOfTheDay: [],
        };

        this.dailyRef = React.createRef();
        this.weeklyRef = React.createRef();
    }

    //this is needed for redirectToReports
    static contextTypes = {
        router: PropTypes.object
    }

    async componentDidMount() {
        try {
            this.setState({ isLoading: true });
            await Promise.all([this.loadSettings(), this.loadFilters()]);
        } catch (error) {
            Notification("error", "Error", error);
        } finally {
            this.setState({ isLoading: false });
        }

        $(this.dailyRef.current).popover();
        $(this.weeklyRef.current).popover();
    }

    loadSettings = async () => {
        try {
            const response = await this.props.userActions.loadNotificationSettings(this.props.subscriptionId, this.props.userId);
            if (response.type === types.LOAD_NOTIFICATION_SETTINGS_SUCCESS) {
                const notifSettings = response.payload.notificationSettings;

                let locationIds = "";
                if (notifSettings.locationIds && notifSettings.locationIds.length > 0) {
                    locationIds = notifSettings.locationIds.join(',');
                }

                const alertDayOfWeekId = (notifSettings.alertDayOfWeekId) ? notifSettings.alertDayOfWeekId.toString() : '';
                const alertHourOfDayId = this.convertHourToLocal(notifSettings.alertHourOfDayId);
                const alertOnSpecificLocations = locationIds === "" ? 0 : 1;

                const settings = {
                    ...notifSettings,
                    locationIds,
                    alertDayOfWeekId,
                    alertHourOfDayId,
                    alertOnSpecificLocations
                };

                this.props.updateSettings(settings);

            } else if (response.type === types.LOAD_NOTIFICATION_SETTINGS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    convertHourToLocal = (hourOfDay) => {
        if (!hourOfDay) {
            return '0';
        }

        var localHour = moment.utc(hourOfDay, "HH").tz(this.props.timezone).format("H");

        if (localHour == "0") {
            return '24';
        }

        return localHour.toString();
    }
    
    loadFilters = async () => {
        try {
            const response = await this.props.userActions.loadNotificationFilters(this.props.subscriptionId, this.props.userId);
            if (response.type === types.LOAD_NOTIFICATION_FILTERS_SUCCESS) {
                this.setState({
                    ...this.state,
                    locations: response.payload.locations,
                    daysOfTheWeek: response.payload.daysOfTheWeek,
                    hoursOfTheDay: response.payload.hoursOfTheDay,
                    userDefaultLocation: response.payload.userDefaultLocation,
                    isProjectWidgetActive: response.payload.isProjectWidgetActive
                });
            } else if (response.type === types.LOAD_NOTIFICATION_FILTERS_FAILURE) {
                Notification("error", "An Error Occurred", response.payload.message);
            }
        } catch (error) {
            Notification("error", "Error", error);
        }
    }

    onFormChange = (name, value) => {

        const settings = {
            [name]: value
        }

        this.props.updateSettings(settings);
    };

    redirectToReports = () => {
        this.context.router.history.push(Routes.Reports);
    };

    onSelectBoxChange = (value, name) => {
        this.onFormChange(name, value.toString());
    };

    onAlertOnSpecificLocationsChange = (value) => {
        this.onFormChange('alertOnSpecificLocations', value);
    };

    render() {

        const className = this.props.settings.isFormValid ? "notifications-form" : "notifications-form was-validated";

        return (
            <LoadingIndicator isLoading={this.state.isLoading}>
                {this.props.userFullName &&
                    <div className="mb-2">Name: {this.props.userFullName}</div>
                }
                <form className={className} noValidate>

                    {this.state.showAdminSection &&
                        <div className="admin-notification section">
                            <div className="row content">
                                <div className="col-12 col-sm-4 header">
                                    <h4>Admin Notifications</h4>
                                </div>
                                <div className="col-12 col-sm-8 fields">
                                    <div className="row">
                                        <div className="col-8">
                                            <p>Email me when a new user request has been submitted.</p>
                                        </div>
                                        <div className="col-4">
                                            <Toggle text="" name="alertOnNewUserRequest" checked={this.props.settings.alertOnNewUserRequest} onChange={this.onFormChange} />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-8">
                                            <p>Email me when a location is created.</p>
                                        </div>
                                        <div className="col-4">
                                            <Toggle text="" name="alertOnLocationCreated" checked={this.props.settings.alertOnLocationCreated} onChange={this.onFormChange} />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    }

                    <div className="section">
                        <div className="row content">
                            <div className="col-12 col-sm-4 header">
                                <h4>Notification Configuration</h4>
                                <p>These settings determine which tasks are included in your email notifications and when notifications should be sent.</p>
                            </div>
                            <div className="col-12 col-sm-8 fields">
                                <div className="row">
                                    <div className={(this.props.isUsedInDrawer) ? "col-md-12": "col-md-6"}>
                                        <p>Send me alerts for:</p>
                                    </div>
                                    <div className={(this.props.isUsedInDrawer) ? "col-md-12 radio-group": "col-md-6 radio-group"}>
                                        <RadioGroup 
                                            defaultValue={this.props.settings.alertOnSpecificLocations}
                                            value={this.props.settings.alertOnSpecificLocations}
                                            options={[
                                                {  value: 0, label: `${this.state.userDefaultLocation && this.state.userDefaultLocation !== "" ? this.state.userDefaultLocation : "Default Location"} only` },
                                                {  value: 1, label: 'Specific Locations' },
                                            ]}
                                            onValueChange={this.onAlertOnSpecificLocationsChange} />
                                    </div>
                                </div>
                                {this.props.settings.alertOnSpecificLocations === 1 &&
                                    <div>
                                        <div className="row">
                                            <div className="col">
                                                <MultiSelectBox name="locationIds" label="Locations" idField="id" valueField="name"
                                                    options={this.state.locations}
                                                    selectedValues={this.props.settings.locationIds}
                                                    onChange={this.onSelectBoxChange}
                                                    isRequired={this.props.settings.alertOnSpecificLocations === 1}
                                                    errorMessage="Location is required"
                                                    isMulti={true}/>
                                            </div>
                                        </div>
                                        {this.props.settings.locationIds.split(",").length > 5 &&
                                            <div className="row">
                                                <div className="col">
                                                    <div className="alert alert-secondary">
                                                        <div className="row">
                                                            <div className="col-6">
                                                                Email notifications are most effective for five or less locations. For more locations, consider creating a scheduled report.
                                                            </div>
                                                            <div className="col-6">
                                                                <Button type="button" bootstrapClass="secondary" text="Create Scheduled Report" onClick={this.redirectToReports} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                }
                                <div className="row">
                                    <div className={(this.props.isUsedInDrawer) ? "col-md-12": "col-md-6"}>
                                        <MultiSelectBox name="alertHourOfDayId" label="Send notifications around this time of day" idField="id" valueField="name"
                                            options={this.state.hoursOfTheDay}
                                            selectedValues={this.props.settings.alertHourOfDayId}
                                            onChange={this.onSelectBoxChange}
                                            isRequired={true}
                                            errorMessage="An hour must be selected"
                                            isMulti={false} />
                                    </div>
                                    <div className={(this.props.isUsedInDrawer) ? "col-md-12": "col-md-6"}>
                                        <MultiSelectBox name="alertDayOfWeekId" label="Send Weekly notifications on this day" idField="id" valueField="name"
                                            options={this.state.daysOfTheWeek}
                                            selectedValues={this.props.settings.alertDayOfWeekId}
                                            onChange={this.onSelectBoxChange}
                                            isRequired={true}
                                            errorMessage="A day must be selected"
                                            isMulti={false} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col">
                                        <div className="alert alert-secondary">
                                            <div className="row">
                                                <div className="col-12">
                                                    Time is in {this.props.timezoneString} - No adjustment for Daylight Savings Time
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="section">
                        <div className="row content">
                            <div className="col-12 col-sm-4 header">
                                <h4>Event Notifications</h4>
                                <p>Get notified via email when these items occur.</p>
                            </div>
                            <div className="col-12 col-sm-8 fields">
                                <div className="row">
                                    <div className="col-8 with-popover">
                                        <p>Email me the daily digest.</p>
                                        <div ref={this.dailyRef}
                                            id="daily-popover"
                                            data-toggle="popover"
                                            title={DailyDigestPopover.Title}
                                            data-placement="bottom"
                                            data-content={DailyDigestPopover.Body}>
                                            <Icon name="info-circle" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertForDailyDigest" checked={this.props.settings.alertForDailyDigest} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8 with-popover">
                                        <p>Email me the weekly digest.</p>
                                        <div ref={this.weeklyRef}
                                            id="weekly-popover"
                                            data-toggle="popover"
                                            title={WeeklyDigestPopover.Title}
                                            data-placement="bottom"
                                            data-content={WeeklyDigestPopover.Body}>
                                            <Icon name="info-circle" />
                                        </div>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertForWeeklyDigest" checked={this.props.settings.alertForWeeklyDigest} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                {this.state.isProjectWidgetActive &&
                                    <div className="row">
                                        <div className="col-8">
                                            <p>Email me when a new Project is assigned to location(s) selected.</p>
                                        </div>
                                        <div className="col-4">
                                            <Toggle text="" name="alertOnProjectAssigned" checked={this.props.settings.alertOnProjectAssigned} onChange={this.onFormChange} />
                                        </div>
                                    </div>                                
                                }
                                <div className="row">
                                    <div className="col-8">
                                        <p>Email me when I am tagged in a comment.</p>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertOnCommentTag" checked={this.props.settings.alertOnCommentTag} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <p>Email me about system changes, updates, and training tips.</p>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertOnSystemUpdates" checked={this.props.settings.alertOnSystemUpdates} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <p>Email me if a task is marked as Need Resources.</p>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertOnNeedResources" checked={this.props.settings.alertOnNeedResources} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <p>Show me Tips and What&apos;s New alerts.</p>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="isToolTipsActive" checked={this.props.settings.isToolTipsActive} onChange={this.onFormChange} />
                                    </div>
                                </div>
                                <div className="row">
                                    <div className="col-8">
                                        <p>Email me when I am assigned tasks (once per day).</p>
                                    </div>
                                    <div className="col-4">
                                        <Toggle text="" name="alertOnAssignedTask" checked={this.props.settings.alertOnAssignedTask} onChange={this.onFormChange} />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
            </form>
        </LoadingIndicator>
        )
    }
}

NotificationSettingsForm.propTypes = {
    subscriptionId: PropTypes.string,
    settings: PropTypes.object.isRequired,
    updateSettings: PropTypes.func.isRequired,
    userActions: PropTypes.object.isRequired,
    userId: PropTypes.number.isRequired,
    userRole: PropTypes.string.isRequired,
    userFullName: PropTypes.string,
    isUsedInDrawer: PropTypes.bool,
    timezone: PropTypes.string,
    timezoneString: PropTypes.string
};

function mapDispatchToProps(dispatch) {
    return {
        userActions: bindActionCreators(userActions, dispatch)
    };
}

export default connect(null, mapDispatchToProps)(NotificationSettingsForm);